<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="toolBar">
      <van-dropdown-menu style="width:100%">
        <van-dropdown-item v-model="search.isSelf" :options="optionIsSelf" @change="onSearch" />
        <van-dropdown-item v-model="search.isResult" :options="optionIsResult" @change="onSearch" />
        <van-dropdown-item v-model="search.dateOffect" :options="optionDate" @change="onSearch" />
      </van-dropdown-menu>
    </div>
    <div class="emptyRect" />
    <div class="dataRect">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.data.userBirthdayMaintenanceId" class="dataLine">
          <div class="Icon" @click="onSelectItem(item)">
            <van-image
              v-if="item.infoBase"
              width="4em"
              height="5.5em"
              fit="cover"
              radius="0.4em"
              lazy-load
              :src="item.infoBase.headIcon"
            />
            <van-image
              v-if="!item.infoBase"
              width="4em"
              height="5em"
              fit="cover"
              radius="0.4em"
              lazy-load
              :src="item.user.icon?item.user.icon:'/img/defaultUserIcon.jpg'"
            />
          </div>
          <div v-if="item.infoBase" class="dataRect">
            <van-row>
              <van-col span="12" class="data">
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.infoBase.loaclName ;">
                  <span :style="'color:'+GetColorMainBack()">姓名: </span>{{ item.infoBase.loaclName }} {{ item.infoBase.sex }}
                </div>
              </van-col>
              <van-col span="12" class="rigth">
                <van-tag v-if="item.isSelf" type="primary">我的学员</van-tag>
                <van-tag v-if="!item.isSelf" type="warning">中心学员</van-tag>
                <van-tag v-if="item.data.resultTime && item.data.isPass" style="margin-left:0.5em" type="warning">已反馈</van-tag>
                <van-tag v-if="item.data.resultTime && !item.data.isPass" style="margin-left:0.5em" type="danger">异常反馈</van-tag>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12" class="data breakAll">
                <span :style="'color:'+GetColorMainBack()">Name: </span>{{ item.infoBase.lastName }} {{ item.infoBase.firstName }}<br>
                <span :style="'color:'+GetColorMainBack()">昵称: </span>{{ item.localName }}<br>
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.infoBase.phone;">
                  <span :style="'color:'+GetColorMainBack()">手机: </span>{{ item.infoBase.phoneCountry }} {{ item.infoBase.phone }}
                </div>

              </van-col>
              <van-col span="12" class="data breakAll">
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.infoBase.email;">
                  <span :style="'color:'+GetColorMainBack()">电子邮箱: </span>{{ item.infoBase.email }}
                </div>
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.socialMediaAccount;">
                  <span :style="'color:'+GetColorMainBack()">社交媒体账号: </span>{{ item.socialMediaAccount }}<br>
                </div>
              </van-col>
            </van-row>

          </div>
          <div v-if="!item.infoBase" class="dataRect">
            <van-row>

              <van-col span="12" class="data">
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.user.localName;">
                  <span :style="'color:'+GetColorMainBack()">姓名: </span>{{ item.user.localName }}
                </div></van-col>
              <van-col span="12" class="rigth">
                <van-tag v-if="item.isSelf" type="primary">我的学员</van-tag>
                <van-tag v-if="!item.isSelf" type="warning">中心学员</van-tag>
                <van-tag v-if="item.data.resultTime && item.data.isPass" style="margin-left:0.5em" type="success">已反馈</van-tag>
                <van-tag v-if="item.data.resultTime && !item.data.isPass" style="margin-left:0.5em" type="danger">异常反馈</van-tag>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12" class="data breakAll">
                <span :style="'color:'+GetColorMainBack()">Name: </span>{{ item.user.lastName }} {{ item.user.firstName }}<br>
                <span :style="'color:'+GetColorMainBack()">昵称: </span>{{ item.localName }}<br>
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.user.phone;">
                  <span :style="'color:'+GetColorMainBack()">手机: </span>{{ item.user.phoneArea }} {{ item.user.phone }}
                </div>
              </van-col>
              <van-col span="12" class="data breakAll">
                <div v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" class="breakAll" @click="copyStr=undefined;copyStr= item.user.email;">
                  <span :style="'color:'+GetColorMainBack()">电子邮箱: </span>{{ item.user.email }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </div>
    <van-popup v-model="showAddResult" position="bottom" class="addRect">
      <van-row>
        <van-col span="4" />
        <van-col span="16" class="titleLine center">提交关系维护反馈</van-col>
        <van-col span="4" class="titleLine rigth"><i class="iconfont iconclosex" @click="showAddResult= false" /></van-col>
      </van-row>
      <div class="dataRect">
        <van-row v-if="selectItem && selectItem.infoBase">
          <van-col span="12" class="data">
            <span :style="'color:'+GetColorMainBack()">姓名: </span>{{ selectItem.infoBase.loaclName }}<br>
          </van-col>
          <van-col span="12" class="data">
            <span :style="'color:'+GetColorMainBack()">Name: </span>{{ selectItem.infoBase.lastName }} {{ selectItem.infoBase.firstName }}<br>
          </van-col>
        </van-row>
        <van-row v-if="selectItem && !selectItem.infoBase">
          <van-col span="12" class="data">
            <span :style="'color:'+GetColorMainBack()">姓名: </span>{{ selectItem.user.localName }}
          </van-col>
          <van-col span="12" class="data">
            <span :style="'color:'+GetColorMainBack()">Name: </span>{{ selectItem.user.lastName }} {{ selectItem.user.firstName }}
          </van-col>
        </van-row>
        <van-row v-if="selectItem && selectItem.data.resultTime">
          <van-col span="12" class="data">
            <span :style="'color:'+GetColorMainBack()">提交时间: </span>{{ formatDate(selectItem.data.resultTime,"yyyy/MM/dd hh:mm",true) }}
          </van-col>
          <van-col span="12" class="data">
            <span :style="'color:'+GetColorMainBack()">提交人: </span>{{ selectItem.coachName }}
          </van-col>
        </van-row>

        <van-row v-if="selectItem">
          <van-col span="24" class="data">
            <span :style="'color:'+GetColorMainBack()">备注:</span>
            <van-field
              v-model="formData.remark"
              rows="2"
              autosize
              style="padding:0;border-bottom:none;"
              type="textarea"
              maxlength="512"
              placeholder="请输入备注"
              class="inputRect"
            />
            <van-uploader
              v-model="fileList"
              class="imageUpload"
              :max-count="1"
              :after-read="afterRead"
              preview-size="60px"
            />
          </van-col>
        </van-row>
        <van-button :color="GetColorMainBack()" size="normal" class="downButton" :loading="buttonLoading" @click="onSave">保存</van-button>
      </div>
    </van-popup>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, DropdownMenu, DropdownItem, Tag, Image, Lazyload, List, Popup, Field, Uploader } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, compressorImageList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [List.name]: List,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '生日顾客关系维护',
      backurl: '/pro/index',
      search: {
        isSelf: true,
        isResult: undefined,
        dateOffect: 0,
        limit: 30,
        page: 1
      },
      loading: undefined,
      finished: false,
      list: [],
      optionIsSelf: [],
      optionIsResult: [],
      optionDate: [],
      showAddResult: false,
      selectItem: undefined,
      formData: {
        userBirthdayMaintenanceId: undefined,
        remark: '',
        resultImg: undefined
      },
      fileList: [],
      buttonLoading: false,
      copyStr: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.optionIsSelf.push({ text: '不限教练', value: undefined, isEnable: true })
    this.optionIsSelf.push({ text: '我的学员', value: true, isEnable: true })
    this.optionIsSelf.push({ text: '中心学员', value: false, isEnable: true })
    this.optionIsResult.push({ text: '不限状态', value: undefined, isEnable: true })
    this.optionIsResult.push({ text: '已反馈', value: true, isEnable: true })
    this.optionIsResult.push({ text: '未反馈', value: false, isEnable: true })
    this.optionDate.push({ text: '今天', value: 0, isEnable: true })
    this.optionDate.push({ text: '昨天', value: -1, isEnable: true })
    this.optionDate.push({ text: '前天', value: -2, isEnable: true })
    this.optionDate.push({ text: '大前天', value: -3, isEnable: true })
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onSearch() {
      console.log('onSearch', this.search)
      this.init()
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      console.log('onLoad')
      //   if (this.loading === undefined) {
      //     this.loading = true
      //     return
      //   }
      this.loading = true
      request({
        url: '/Pro/GetUserBirthdayMaintenance',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onSelectItem(item) {
      this.selectItem = item
      this.formData.userBirthdayMaintenanceId = item.data.userBirthdayMaintenanceId
      this.formData.remark = item.data.remark
      this.formData.resultImg = item.data.resultImg
      if (item.data.resultImg) {
        this.fileList = [{ url: item.data.resultImg }]
      } else {
        this.fileList = []
      }
      this.showAddResult = true
    },
    afterRead(file) {
      console.log('file', file)
    },
    onCopySuccess(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    },
    uploadImg(files, callback) {
      var noFile = true
      var fileList = []
      files.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        } else {
          fileList.push(value.url)
        }
      })
      if (noFile) {
        if (callback) {
          callback(fileList.toString())
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=usermaintenance',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    onSave() {
      this.buttonLoading = true
      this.uploadImg(this.fileList, (fileStr) => {
        this.formData.resultImg = fileStr
        request({
          url: '/Pro/UpdateUserBirthdayMaintenance',
          method: 'post',
          data: this.formData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            this.error = true
            return
          }
          MyNotify('success', '保存进度成功', 2000)
          this.showAddResult = false
          this.list.forEach(item => {
            if (item.data.userBirthdayMaintenanceId === this.formData.userBirthdayMaintenanceId) {
              item.data = response.data
            }
          })
        })
      })
    }
  }
}
</script>
<style scoped>
.toolBar{
    right: 0;
    position: fixed;
    left: 0;
    top: 3em;
    height: 3em;
    z-index: 1;
}
.emptyRect{
    height: 3em;
}
.dataLine{
    background-color: #fff;
    margin-bottom: 0.5em;
    padding: 0.5em;
    position: relative;
    height: 5.5em;
}
.dataLine .Icon{
    position: absolute;
    left: 0.5em;
    top:0.5em
}
.dataLine .dataRect{
    margin-left: 4.5em;
}
.dataLine .dataRect .data{
    font-size: 0.8em;
}
.dataLine .dataRect .data span{
    font-weight: 700;
}

.addRect{
    background-color: #fff;
    width: 100%;

}
.addRect .titleLine{
    line-height: 2em;
    border-bottom: 1px solid #f5f5f5;
    padding: 0.5em 1em;
}
.addRect .dataRect{
    padding: 1em;
    font-size: 0.8em;
}
.addRect .dataRect .data span{
    font-weight: 700;
}
.addRect .downButton{
    width: 100%;
    margin-top: 1em;
}
.addRect .imageUpload{
  margin-top: 0.5em;
}
</style>
